import React from 'react';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import HomepagePackagesBlockData from 'Models/Content/HomepagePackagesBlockData';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';

const HomepagePackagesBlock = (props: ComponentProps<HomepagePackagesBlockData>) => {
  const {data, context} = props;
  return (
    <BlockWrapper props={props} disableFadeIn>
      <div className='w-100'>
        <div className='HomepagePackagesBlock'>
          <ContentArea noWrap context={context} data={data.items} />
        </div>
      </div>
    </BlockWrapper>
  );
};

export default HomepagePackagesBlock;
